import './WhoItsFor.css';

import forYouIllustration from '../../assets/alliatus/for-you-illustration.png';
import notForYouIllustration from '../../assets/alliatus/not-for-you-illustration.png';

const FOR_YOU = [
    <>You’re{' '}<strong>actively searching</strong>{' '}or seriously exploring your next role</>,
    <>You want{' '}<strong>smarter matches</strong>, not another endless job board scroll</>,
    <>You’re ready to leverage{' '}<strong>AI, data, and your network</strong></>,
    <>You value{' '}<strong>targeted outreach</strong>{' '}over spray-and-pray applications</>,
];

const NOT_FOR_YOU = [
    'You’re only casually browsing with no intent to apply',
    'You won’t share a basic profile or resume to get started',
    'You want someone else to run the entire search for you',
    'You’re looking for a traditional recruiting agency',
];

const TESTIMONIALS = [
    {
        quote: '“Numus cut through the noise. Instead of applying to everything, I focused on roles where I actually had a network edge — and interviews followed.”',
        author: '— Taylor B. / Product Manager',
    },
    {
        quote: '“I went from scattershot applications to a short list of high-fit roles. The AI matches felt eerily on-point for my background.”',
        author: '— Samir R. / Software Engineer',
    },
    {
        quote: '“Seeing which companies my network could unlock changed how I outreach. Warm intros beat cold emails every time.”',
        author: '— Renee L. / Marketing Lead',
    },
    {
        quote: '“I used to spend hours filtering listings. Numus surfaces what matters and keeps my pipeline moving without the burnout.”',
        author: '— Alex M. / Data Analyst',
    },
    {
        quote: '“This isn’t another job board — it feels like a search partner. I landed two strong interviews in my first three weeks.”',
        author: '— Jordan K. / UX Designer',
    },
];

function WhoItsFor() {
    return (
        <>
            <section className="al-section" id="who">
                <div className="al-shell">
                    <div className="al-section-head al-section-head--center">
                        <p className="al-eyebrow">Who It’s For</p>
                        <h2 className="al-display">
                            Built for People <span className="al-em">Ready to Move</span>
                        </h2>
                    </div>
                    <div className="al-who-grid">
                        <article className="al-who-card al-who-card--yes">
                            <h3 className="al-h3">
                                This <span className="al-em">Is</span> <span className="al-em">for You</span> If...
                            </h3>
                            <div className="al-who-tags">
                                {FOR_YOU.map((item, index) => (
                                    <div className="al-tag" key={index}>{item}</div>
                                ))}
                            </div>
                            <img
                                className="al-who-art"
                                src={forYouIllustration}
                                alt="Illustration of people collaborating on a job search"
                            />
                        </article>
                        <article className="al-who-card al-who-card--no">
                            <h3 className="al-h3">
                                This Is <span className="al-black-em">NOT</span>{' '}
                                <span className="al-em">for You</span> If...
                            </h3>
                            <img
                                className="al-who-art"
                                src={notForYouIllustration}
                                alt="Illustration of a disconnected job search approach"
                            />
                            <div className="al-who-tags al-who-tags--end">
                                {NOT_FOR_YOU.map((item) => (
                                    <div className="al-tag" key={item}>{item}</div>
                                ))}
                            </div>
                        </article>
                    </div>
                </div>
            </section>

            <section className="al-section" id="testimonials">
                <div className="al-shell">
                    <div className="al-testimonials-layout">
                        <div className="al-section-head">
                            <p className="al-eyebrow">Testimonials</p>
                            <h2 className="al-display">
                                What Job Seekers <span className="al-em">Are Saying</span>
                            </h2>
                        </div>
                        {TESTIMONIALS.map((item) => (
                            <article className="al-quote-card" key={item.author}>
                                <p className="al-body">{item.quote}</p>
                                <p className="al-quote-author">{item.author}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default WhoItsFor;
